export default __webpack_public_path__ + "static/media/isslocator.7092c9e6.png";